'use client'
import { DynamicWalletClient } from '@dynamic-labs-wallet/browser-wallet-client';
import { version } from '../package.js';
import { DEFAULT_BASE_API_URL, DEFAULT_BASE_MPC_RELAY_API_URL } from '../utils/constants.js';

const withDynamicWaas = (BaseClass) => {
    class DynamicWaasMixin extends BaseClass {
        setGetAuthTokenFunction(getAuthToken) {
            this.getAuthToken = getAuthToken;
        }
        setEnvironmentId(environmentId) {
            this.environmentId = environmentId;
        }
        setBaseApiUrl(baseApiUrl) {
            this.baseApiUrl = baseApiUrl;
        }
        setRelayUrl(relayUrl) {
            this.relayUrl = relayUrl;
        }
        setGetSignedSessionIdFunction(getSignedSessionId) {
            this.getSignedSessionId = getSignedSessionId;
        }
        constructor(...args) {
            super(...args);
            this.name = 'Dynamic Waas';
            this.overrideKey = 'dynamicwaas';
            this.isEmbeddedWallet = true;
            // Get the class name from the constructor
            const { connectedChain } = this;
            // Map class names to chain names
            const chainNameMap = {
                EVM: 'EVM',
                SOL: 'SVM',
                SUI: 'SUI',
            };
            const chainName = chainNameMap[connectedChain];
            if (!chainName) {
                throw new Error(`Unsupported chain: ${connectedChain}`);
            }
            this.chainName = chainName;
        }
        createDynamicWaasClient() {
            var _a;
            const authToken = (_a = this.getAuthToken) === null || _a === void 0 ? void 0 : _a.call(this);
            if (!authToken) {
                throw new Error('Auth token is required');
            }
            if (!this.environmentId) {
                throw new Error('Environment ID is required');
            }
            return new DynamicWalletClient({
                authToken,
                baseApiUrl: this.baseApiUrl || DEFAULT_BASE_API_URL,
                baseMPCRelayApiUrl: this.relayUrl || DEFAULT_BASE_MPC_RELAY_API_URL,
                chainName: this.chainName,
                environmentId: this.environmentId,
                sdkVersion: version,
            });
        }
        getWaasWalletClient() {
            if (!this.dynamicWaasClient) {
                this.dynamicWaasClient = this.createDynamicWaasClient();
            }
            return this.dynamicWaasClient;
        }
    }
    return DynamicWaasMixin;
};

export { withDynamicWaas };
